import React from 'react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { TeachingFlow } from './TeachingFlow';
import { systemFlow } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';

/** Section 15 — closing argument with a direct checkout button. */
export function FinalCtaSection() {
  return <section aria-labelledby="final-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-91" data-mp="103jszuhrjbpj">
      <img src={MOCKUP_URL} alt="The complete Makeup Instructor Ready system" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto block w-full max-w-6xl rounded-[18px] shadow-[0_40px_80px_-40px_rgba(59,27,87,0.45)] sm:rounded-[24px]" data-id="element-92" data-mp="cdpel8hspf36" />

      <div className="mx-auto mt-12 max-w-3xl text-center" data-id="element-93" data-mp="hapndr614vxz">
        <h2 id="final-heading" className="font-display text-[2.4rem] font-bold leading-[1.04] text-brand-charcoal sm:text-[3.1rem]" data-id="element-94" data-mp="3pqretscxb2nl">
          Your Makeup Skills Deserve a <Accent data-id="element-95" data-mp="2kq79n0ty8fiw">Professional Teaching System.</Accent>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-[16px] font-semibold leading-relaxed text-brand-charcoal sm:text-[17px]" data-id="element-96" data-mp="2ppjvpjczxikf">
          Stop piecing classes together from scattered notes, old documents and last-minute ideas.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-[16px]" data-id="element-97" data-mp="2zele1g70kc1k">
          Bring structure to what you teach, clarity to how students practice, and consistency to how you
          evaluate progress.
        </p>

        <TeachingFlow steps={systemFlow} size="lg" className="mt-10" data-id="element-98" data-mp="2bpsnjz95uwec" />

        <p className="mt-10 font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-99" data-mp="2bsom9psu1p3u">
          Get the Complete System for <Accent data-id="element-100" data-mp="3n4fmllkaveg0">$27</Accent>
        </p>
        <CtaBlock label="Get Makeup Instructor Ready Now" action="checkout" note="6 Core Volumes + 5 Extra Bonuses • Instant Digital Access • One-Time Payment" className="mt-6" data-id="element-101" data-mp="3n7jzd7btziia" />
      </div>
    </section>;
}